<template>
  <v-dialog content-class="page-vvip-popup" v-model="show" transition="dialog-bottom-transition">
    <v-card class="px-0" @click="show = false;">
      <v-img
        class="img-vvip-pop"
        cover
        :src="`${cdnUrl}/assets/images/loyalty/${profile.hq_merchant_id}/popup/vvip-upgrade.webp`"
        v-if="!isVvip"
      ></v-img>
      <div class="home-sec" v-if="isVvip">
        <v-img
          contain
          class="text-center mx-auto mt-3 px-0"
          width="100%"
          style="aspect-ratio: 3/2;"
          position="center"
          :src="currentTierProfileCardSrc"
        >
          <div class="profile-customer-name position-absolute">
            <div class="text-body-2 text-left tertiary--text font-weight-bold">{{ name }}</div>
            <div class="text-caption text-left label--text font-weight-6">{{ loyaltyCustomer.contactPhone }}</div>
          </div>
        </v-img>
        <div class="text-center mt-8 mb-4 px-8">
          <v-img
            src="@/assets/dayonedayone/images/vvip-onboarding-title.webp"
            contain
            max-height="24"
            class="mx-auto"
          ></v-img>
        </div>
        <v-container class="px-4 mb-2">
          <v-row>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-onboarding-gift.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">会员首次礼遇<span class="red-dot"></span></div>
            </v-col>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-birthday.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">生日蛋糕<span class="red-dot"></span></div>
            </v-col>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-daily-perks.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">每月周边好礼</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-drinknsnack-offer.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">饮料小吃会员价<span class="red-dot"></span></div>
            </v-col>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-new-menu-tasting.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">新品试吃体验官</div>
            </v-col>
            <v-col cols="4" class="py-2 text-center">
              <v-img src="@/assets/dayonedayone/images/vvip-pre-booking.webp" contain height="60" class="mb-1"></v-img>
              <div class="text-caption vvip-perks-label">预订服务<span class="red-dot"></span></div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  props: ['visible'],
  data() {
    return {
      cdnUrl: process.env.VUE_APP_CDN_R2_URL,
    };
  },
  computed: {
    ...mapState('customer', ['customer']),
    ...mapState('loyalty', {
      loyaltyCustomer: (state) => state.customer,
    }),
    ...mapState('merchant', {
      profile: (state) => state.profile,
    }),
    ...mapGetters('client', {
      name: 'getName',
    }),
    isVvip() {
      return this.loyaltyCustomer?.loyaltyTier?.vvip;
    },
    currentTierProfileCardSrc() {
      if (!this.loyaltyCustomer || !this.loyaltyCustomer.loyaltyTier) {
        return require(`@/assets/dayonedayone/images/profile-loyalty-card.webp`);
      }
      return `${this.cdnUrl}/assets/images/loyalty/${this.profile.hq_merchant_id}/tiers/profile-card-${this.loyaltyCustomer.loyaltyTier.sortOrder}.webp`;
    },
    show: {
      get: function () {
        return this.visible;
      },
      set: function (val) {
        if (!val) {
          this.$emit('close-popup', false);
        }
      },
    },
  },
  methods: {
    ...mapActions('data', ['createDataAnalyticEvent']),
    viewed() {
      this.createDataAnalyticEvent({
        event: 'upgrade-vvip-popup-viewed',
        data: {
          hqMerchantId: this.profile.hq_merchant_id,
          merchantId: this.profile.merchant_id,
          refTable: this.loyaltyCustomer ? 'loyalty_clients' : (this.customer ? 'client' : 'uuid'),
          refId: this.loyaltyCustomer?.id ?? this.customer?.phoneNo ?? localStorage.uuid,
          category: 'engagement',
        },
      });
    },
  }
};
</script>

<style>
.page-vvip-popup {
  height: 90dvh;
  border-radius: 20px !important;
  margin-top: -20px;
}

.page-vvip-popup .v-card {
  background-color: rgba(247, 239, 232, 0.9) !important;
}

.page-vvip-popup .img-vvip-pop {
  /* height: calc(80dvh - 80px - 60px); */
}
</style>
<style scoped>
.home-sec {
  background-image: url('~@/assets/dayonedayone/images/profile-background.webp');
  background-size: cover;
  background-position: bottom;
  background-color: #f7efe8;
  height: calc(90dvh + 8px);
  margin-top: -20px;
}

.container-loyalty-tier, .container-loyalty-benefit {
  background-color: #e1cfc7;
}

.loyalty-tier-name {
  font-size: 8px;
}

.footer-divider {
  background-color: rgb(249, 244, 236);
}

.profile-customer-name {
  left: 24px;
  bottom: 12px;
}

.vvip-perks-label {
  font-size: 10px !important;
  display: inline-block;
}

.red-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #d32f2f;
  margin-left: 1px;
  vertical-align: text-top;
}
</style>
